const GOOGLE_ADDRESS_BOUND_FLAG = "__gAddressBound";

async function initAutocomplete() {
	await google.maps.importLibrary("places");
	ensurePacContainerZIndex();
	bindAll();
}

function bindAll() {
	const inputs = document.querySelectorAll(".gAddressSearch");
	inputs.forEach(bindOne);
}

function isVisible(el) {
	return el.offsetParent !== null;
}

function ensurePacContainerZIndex() {
	if (document.getElementById("gAddressPacStyle")) return;
	const style = document.createElement("style");
	style.id = "gAddressPacStyle";
	style.textContent = ".pac-container { z-index: 10000 !important; }";
	document.head.appendChild(style);
}

function bindOne(input) {
	if (input[GOOGLE_ADDRESS_BOUND_FLAG]) return;
	if (typeof google === "undefined" || !google.maps || !google.maps.places) return;
	if (!isVisible(input)) return;

	const scope = input.closest(".googleAddressScope");
	if (!scope) return;

	const countryAttr = input.getAttribute("data-country-codes") || "[]";
	let countryCodes = [];
	try {
		countryCodes = JSON.parse(countryAttr).map(c => c.toLowerCase());
	} catch (e) {
		countryCodes = [];
	}

	const autocomplete = new google.maps.places.Autocomplete(input, {
		types: ["geocode"],
		componentRestrictions: countryCodes.length > 0 ? { country: countryCodes } : undefined
	});

	google.maps.event.addListener(autocomplete, "place_changed", () => {
		const place = autocomplete.getPlace();
		if (place) {
			fillInAddress(place, scope);
		}
	});

	input[GOOGLE_ADDRESS_BOUND_FLAG] = true;
}

function fillInAddress(place, scope) {
	const $scope = $(scope);
	const doorNumber = $scope.find(".googleAddress_inputDoorNumber");
	const components = place.address_components || [];

	for (const component of components) {
		const componentType = component.types[0];

		switch (componentType) {
			case "postal_code":
				$scope.find(".googleAddress_inputPostalcode").val(component.long_name);
				break;

			case "locality":
				$scope.find(".googleAddress_inputLocality").val(component.long_name);
				break;

			case "route":
				$scope.find(".googleAddress_inputStreet").val(component.short_name);
				break;

			case "street_number":
				$scope.find(".googleAddress_inputHousenumber").val(component.long_name);
				break;

			case "country": {
				const $countrySelect = $scope.find(".googleAddress_inputCountry");
				$countrySelect.find("option").each(function () {
					if (component.short_name.toUpperCase() === $(this).attr("data-code")) {
						$countrySelect.val($(this).val()).trigger("change");
					}
				});
				break;
			}
		}
	}

	if (doorNumber.length) doorNumber.focus();
}

window.initAutocomplete = initAutocomplete;
window.rebindGoogleAddress = bindAll;

$(document).on("shown shown.bs.modal", ".modal", bindAll);
$(document).on("click", ".editAddress, .customerAddressNewBtn, #createDeliveryAddress, #createInvoiceAddress, .editAddressBtn", function () {
	setTimeout(bindAll, 0);
});
